module.exports = __webpack_public_path__ + "img/map_outifled-mezzanine-2.1586188c.jpg";